










































import { Component, Prop, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import AppCollapseCard from '@core/components/AppCollapseCard.vue'
import { convertToCurrencyFormat } from '@core/tools/Formatter'
import TheILPDetails from './TheILPDetails.vue'
import { cloneDeep } from 'lodash'
import ILPPortfolioV2 from '@master/model/kyc-form/ILPPortfolioV2'
import { IProjectInfo } from '@master/config/IProjectInfo'
import { BasicProductV2 } from '@master/model/kyc-form/product/BasicProductV2'
import { ProductMeta } from '@master/model/common/ProductMeta'

@Component({
  components: {
    AppCollapseCard,
    TheILPDetails
  }
})
export default class TheILP extends Vue {
  @Prop() ilpPortfolios: ILPPortfolioV2[]
  @Prop() rcmdIlpProducts: BasicProductV2[]
  @Prop({ default: false }) client2Included: boolean
  @Prop() ilpFundList: ProductMeta[]
  @Prop() limitation?: { portfolio: number; funds: number }

  private showModal = false
  private isEdit = false
  private editingIndex = undefined
  private toEditPortfolioModel = new ILPPortfolioV2()

  @inject()
  private projectInfo: IProjectInfo

  convertToCurrencyFormat (value) {
    const { currency } = this.projectInfo
    return convertToCurrencyFormat(value, currency)
  }

  saveProduct (event) {
    const newProduct = cloneDeep(event) as ILPPortfolioV2
    if (this.isEdit) {
      this.ilpPortfolios.splice(this.editingIndex, 1, newProduct)
    } else {
      this.ilpPortfolios.push(newProduct)
    }

    this.$emit('save')
    this.isEdit = false
    this.showModal = false
  }

  get portfoliosToDisplay () {
    return this.ilpPortfolios.filter(card => {
      if (!this.client2Included && card.for === 'C2') return false
      if (!card.oid || !card.name) return false
      return true
    })
  }

  get disabledAddPortfolio () {
    if (typeof this.limitation === 'undefined') {
      return false
    }
    const maxNum = this.limitation.portfolio
    return this.portfoliosToDisplay.length === maxNum
  }

  get maxFundsCanAdd () {
    if (typeof this.limitation === 'undefined') {
      return undefined
    }

    return this.limitation.funds
  }

  getPortfolioTitle (target: any) {
    if (!target) return 'Invalid Card'
    const owner = target.for ? `(${target.for})` : ''
    return `${target.name} ${owner}`
  }

  createPortfolio () {
    // no more empty slot to create
    this.toEditPortfolioModel = new ILPPortfolioV2()
    this.isEdit = false
    this.showModal = true
  }

  editPortfolio (portfolio) {
    this.toEditPortfolioModel = Object.assign(new ILPPortfolioV2(), portfolio)
    this.editingIndex = this.ilpPortfolios.findIndex(_portfolio => portfolio === _portfolio)
    this.isEdit = true
    this.showModal = true
  }

  removePortfolio (portfolio) {
    if (!confirm('Confirm to remove this plan?')) return
    const portfolioIndex = this.ilpPortfolios.findIndex(_portfolio => portfolio === _portfolio)
    this.ilpPortfolios.splice(portfolioIndex, 1)
    this.$emit('save')
  }
}
